export default function TimelineLegend() {
  const errorTypes = [
    { label: 'Syntax Error', color: '#FF6B6B' },
    { label: 'Runtime Error', color: '#FFA500' },
    { label: 'Logic Error', color: '#4169E1' },
    { label: 'Test Failed', color: '#9B9B9B' },
  ]

  return (
    <div className="timeline-legend" style={{
      background: 'white',
      borderRadius: '8px',
      padding: '20px 28px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      flexShrink: 0,
    }}>
      <h2 style={{ fontSize: '17px', fontWeight: 600, margin: '0 0 16px 0', color: '#333' }}>
        Error Legend
      </h2>
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        {errorTypes.map((type, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: type.color,
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
            }} />
            <span style={{ fontSize: '14px', color: '#555' }}>{type.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}